const styles = `:host {
  --chameleon-select-height: 32px;
  --buttons-top-offset: 8px;
  --buttons-right-offset: 8px;
  --input-font-size: 16px;
  --listbox-focus-offset: 0;
}
:host .control {
  --goto-icon-size: 16px;
  position: relative;
  min-height: var(--chameleon-select-height);
  height: unset;
  max-height: calc(var(--chameleon-select-height) * 3);
  overflow-y: scroll;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding-top: var(--goto-spacing-01);
  padding-bottom: var(--goto-spacing-01);
  padding-right: 50px;
}
:host .label {
  font: var(--goto-caption-medium-strong);
}
:host input {
  border: none;
  margin: 0;
  padding: 0;
  width: unset;
  font: var(--goto-body-small);
  font-size: var(--input-font-size);
  line-height: 24px;
}
:host .buttons {
  position: absolute;
  top: var(--buttons-top-offset);
  right: var(--buttons-right-offset);
  display: flex;
}
:host .buttons .close {
  display: none;
  visibility: hidden;
}
:host .buttons .close.visible {
  display: block;
  visibility: visible;
}
:host .close-btn {
  display: none;
  visibility: hidden;
}
:host ::slotted([slot=helper-text]) {
  font: var(--goto-caption-medium);
  color: var(--goto-type-color-secondary);
}
:host ::slotted([slot=start]) {
  color: var(--goto-type-color-secondary);
  --goto-icon-color: var(--goto-icon-color-default);
}

:host(:focus-within) {
  --listbox-focus-offset: 2px;
}
:host(:focus-within) .close-btn[has-selected-option=true] {
  display: block;
  visibility: visible;
}
:host(:focus-within) .control {
  outline: 1px solid var(--goto-focus-color-highlight-default);
  outline-offset: 1px;
}

:host .listbox {
  display: none;
  visibility: hidden;
  max-height: calc(var(--chameleon-select-height) * 9.5);
}

:host .listbox.open {
  display: flex;
  visibility: visible;
  position: absolute;
}

:host([position=below]) .listbox.open {
  top: calc(var(--chameleon-select-height) + 24px);
}

:host([position=above]) .listbox.open {
  bottom: calc(var(--chameleon-select-height) + var(--listbox-focus-offset));
}

:host([size=small]) {
  --chameleon-select-height: 24px;
  --buttons-top-offset: 4px;
  --input-font-size: 14px;
}
:host([size=small]) .control {
  --goto-icon-size: 16px;
}

:host([size=large]) {
  --chameleon-select-height: 40px;
  --buttons-top-offset: 8px;
  --input-font-size: 16px;
}
:host([size=large]) .control {
  --goto-icon-size: 24px;
}

:host([size=xlarge]) {
  --chameleon-select-height: 48px;
  --buttons-top-offset: 12px;
  --input-font-size: 16px;
}
:host([size=xlarge]) .control {
  --goto-icon-size: 24px;
}`; export default styles;